import { useEffect, useState } from 'preact/hooks'
import { useTranslation } from 'react-i18next'
import DynamicFieldset from './DynamicFieldset'
import Input from './Input'
import DailyReportTravelingTimeCard from './DailyReportTravelingTimeCard'
import { Model } from '@/types'

type Props = {
	travelings: Model.Transport[]
    translation: string
}

const TravelingList: FC<Props> = (p) => {
	const { t } = useTranslation(p.translation)
	const [ traveling, setTraveling ] = useState<Model.Transport[]>([] as Model.Transport[])

    useEffect(() => {
        if (p.travelings) {
            setTraveling(p.travelings as Model.Transport[])
        }
    }, [p.travelings])

	return (
		
        <DynamicFieldset
            data={ traveling as Model.Transport[]}
            label={t('traveling')}
            make={(i: number) => (
                <fieldset key={i}>
                    <DailyReportTravelingTimeCard
                        position={i}
                        data={traveling[i]}
                    />
                    <Input 
                        className='span3'
                        autocomplete='on'
                        required
                        name={`transport[${i}][departure]`}
                        label={t('departure')}
                        defaultValue={traveling[i]?.departure?.toString()}
                    />
                    <Input
                        className='span3'
                        autocomplete='on'
                        required
                        name={`transport[${i}][arrival]`}
                        label={t('arrival')}
                        defaultValue={traveling[i]?.arrival?.toString()}
                    />
                    <Input
                        required
                        units='km'
                        name={`transport[${i}][km]`}
                        label={t('total_km')}
                        defaultValue={traveling[i]?.km.toString()}
                    />
                </fieldset>
            )}
        />
		
	)

}
export default TravelingList
